import { rejectInvalidSyncKey } from 'serviceWorker/services/factories/invalidSyncKey';
import type { IssueInDto } from 'shared/dtos/in/issue';
import {
  defaultConfig,
  generateHeaders,
  makeNormalizePagedResponse,
  makeNormalizeResponse,
} from '../../helpers/httpRequests';
import type {
  HeadersData,
  NormalizedEntityResponseData,
  NormalizedPagedEntityResponseData,
} from '../factories/types';
import { pull } from '../pull';

/** The API answers issues under `issues`; the factory reads `items`. */
const parsePagedResponse = makeNormalizePagedResponse<IssueInDto>('issues');
const parseUpdatedResponse = makeNormalizeResponse<IssueInDto>('issues');

/** One page of the issues, archived ones included. */
export const fetchIssuesPaged = (
  data: HeadersData,
  controller: AbortController,
  offset: number,
  size: number
): Promise<NormalizedPagedEntityResponseData<IssueInDto>> | undefined => {
  const { signal } = controller;
  if (!data.api || !data.projectId || signal.aborted) {
    return;
  }
  const builtUrl = `${data.api}/v2/project/${data.projectId}/issue?offset=${offset}&size=${size}&deleted=[true,false]`;

  return pull(builtUrl, {
    ...defaultConfig,
    method: 'GET',
    headers: generateHeaders(data),
    signal,
  }).then(parsePagedResponse);
};

export const fetchUpdatedIssues = (
  data: HeadersData,
  syncKey: string,
  controller: AbortController
): Promise<NormalizedEntityResponseData<IssueInDto>> | undefined => {
  const { signal } = controller;
  if (!data.api || !data.projectId) {
    return;
  }
  const builtUrl = `${data.api}/v2/project/${data.projectId}/issue?syncKey=${encodeURIComponent(syncKey)}`;

  return pull(builtUrl, {
    ...defaultConfig,
    method: 'GET',
    headers: generateHeaders(data),
    signal,
  })
    .then((response: Response) => rejectInvalidSyncKey(response, 'issues'))
    .then(parseUpdatedResponse);
};
